import { isConnectedNode } from "@p0security/shared/graph/types";
import {
  AssessmentNodes,
  IdentityNode,
  IdentityType,
} from "@p0security/shared/types/assessment/data/index";

export const identityTypeToEmoji: Record<IdentityType, string> = {
  agent: "🤖",
  "aws-permission-set-role": "🤝",
  "aws-iam-role": "⚙️",
  "entra-app-registration": "💠",
  "logged-in": "🌎",
  "service-account": "⚙️",
  "service-principal": "⚙️",
  domain: "🌐",
  federated: "🤝",
  group: "👥",
  public: "🌎",
  unknown: "",
  user: "👤",
};

/** Only users and traditional service accounts have credentials */
export const identityTypesWithCredentials: IdentityType[] = [
  "aws-iam-role", // IAM roles and permission set roles only use short-lived credentials
  "aws-permission-set-role",
  "user",
  "service-account",
  "service-principal",
  "entra-app-registration",
];

export const credentialsFor = (node: IdentityNode) =>
  node.parents
    .filter(isConnectedNode("credential"))
    .map((c) => ({ ...c.data, id: c.key }));

export const lastAuthnTimeFor = (
  credentials: (AssessmentNodes["credential"] & {
    id: string;
  })[]
): number | undefined =>
  // Returns undefined if the lastAuthnTime is unknown
  credentials.sort((a, b) => (b.lastAuthnTime ?? 0) - (a.lastAuthnTime ?? 0))[0]
    ?.lastAuthnTime;
